import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
import Loader from './UI/components/Loader';
import Positioned from './UI/components/Positioned';
import router from './router';
import store from './store';
import { HasNoPermissions, HasPermissions } from './UI/directives/HasPermissions';

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: 'https://1b30834ddfc744a79d34be045d89a3a6@o303507.ingest.sentry.io/5605761',
  integrations: [
    new Integrations.BrowserTracing(),
  ],

  tracesSampleRate: 1.0,
});

store.subscribe(mutation => {
  if(mutation.type === 'SET_AUTH_USER'){
    const authUser = mutation.payload;
    if(authUser && authUser.permissions){
      Vue.directive('has-permissions', HasPermissions(authUser.permissions.map(p => p.genericName)));
      Vue.directive('has-no-permissions', HasNoPermissions(authUser.permissions.map(p => p.genericName)));
    }
    else{
      Vue.directive('has-permissions', HasPermissions([]));
      Vue.directive('has-no-permissions', HasNoPermissions([]));
    }
  }
});

Vue.use(VueToast);

Vue.use(BootstrapVue);
Vue.component('Loader', Loader);
Vue.component('Positioned', Positioned);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})
